import { connect } from 'react-redux';
import OutageForm from './OutageForm';
import { updateStationStatus } from '../../actions/station-info';

const mapStateToProps = ({ stationInfo }) => ({
  loading: stationInfo.isSavingOutage,
});

const mapDispatchToProps = dispatch => ({
  updateStationStatus: body => dispatch(updateStationStatus(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutageForm);
